// calculator base functions

$.fn.inputFilter = function(inputFilter) {
    // Restricts input for each element in the set of matched elements to the given inputFilter
    // https://stackoverflow.com/questions/995183/how-to-allow-only-numeric-0-9-in-html-inputbox-using-jquery
    return this.on('input keydown keyup mousedown mouseup select contextmenu drop', function() {
        if (inputFilter(this.value)) {
            this.oldValue = this.value;
            this.oldSelectionStart = this.selectionStart;
            this.oldSelectionEnd = this.selectionEnd;
        } else if (this.hasOwnProperty('oldValue')) {
            this.value = this.oldValue;
            this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
        }
    });
};

$.fn.allInputsContainValues = function (checkActiveOnly = true) {
    let $question = $(this);

    if (checkActiveOnly) {
        if (!$question.hasClass('question--current')) return false;
    }

    let condition = false,
        inputCount = 0,
        inputFilledCount = 0,
        inputNames = {},
        checkboxNames = [];

    $question.find('input, textarea').each(function () {
        inputNames[$(this).attr('name')] = true;
    });

    $.each(inputNames, function () {
        inputCount++;
    });

    $question.find('input').each(function () {
        let type = $(this).attr('type'),
            name = $(this).attr('name');

        if ('radio' === type) {
            if ($(this).is(':checked')) {
                inputFilledCount++;
            }
        } else if ('checkbox' === type) {
            if ($(this).is(':checked') && $.inArray(name, checkboxNames) === -1) {
                checkboxNames.push(name);
                inputFilledCount++;
            }
        } else if ('range' === type) {
            let modified = $(this).attr('data-range-modified');

            if (typeof modified !== 'undefined') {
                if ($(this).val()) {
                    inputFilledCount++;
                }
            }
        } else {
            if ($(this).val()) {
                inputFilledCount++;
            }
        }
    });

    $question.find('textarea').each(function () {
        if ($(this).val()) {
            inputFilledCount++;
        }
    });

    if (inputCount === inputFilledCount) {
        condition = true;
    }

    return condition;
}

$.fn.allQuestionsAnswered = function () {
    let $calculator = $(this);

    if (!$calculator.hasClass('calculator')) return false;

    let $questions = $calculator.find('.question:not(.question--hidden):not([data-conditional-state="hidden"])'),
        allQuestionsAnswered = true;

    $questions.each(function () {
        if (allQuestionsAnswered && !$(this).allInputsContainValues(false)) {
            allQuestionsAnswered = false;
        }
    });

    return allQuestionsAnswered;
}

$.fn.showNextQuestion = function () {
    let $calculator = $(this);

    if (!$calculator.hasClass('calculator')) return false;

    let $questionActive = $('.question.question--current', this);

    if ($questionActive.length > 0) {
        let $questionNext = $questionActive.nextAll('.question:not(.question--hidden):not([data-conditional-state="hidden"])').first();

        if ($questionNext.length > 0) {
            if ($questionActive.allInputsContainValues()) {
                $questionActive.removeClass('question--current');
                $questionNext.addClass('question--current').stop().slideDown(300); // .attr('data-question-visited', '');

                if ($questionActive.find('input[type="checkbox"]').length < 1) {
                    let scrollPosition = $questionNext.offset().top - $('.masthead').outerHeight();

                    $('html, body').stop().animate({
                        scrollTop: scrollPosition
                    }, 1000);

                    if ($questionNext.allInputsContainValues()) {
                        $calculator.showNextQuestion();
                    }
                }
            }
        }
    }
}

$.fn.setQuestionNumbers = function () {
    let $calculator = $(this);

    if (!$calculator.hasClass('calculator')) return false;

    let totalQuestions = $('.calculator__questions .question:not(.question--hidden):not([data-conditional-state="hidden"])', this).length;

    // set total questions
    $('[data-calculator-value="total-questions"]', this).text(totalQuestions);

    // set individual question numbers
    $('.calculator__questions .question:not(.question--hidden):not([data-conditional-state="hidden"]) .question__number', this).each(function () {
        let $question = $(this).closest('.question'),
            index = $question.index() + 1;

        $question.prevAll('.question--hidden, [data-conditional-state="hidden"]').each(function () {
            index--;
        });

        $('[data-calculator-value="question-number"]', this).text(index);
    });
}

$.fn.checkConditionals = function() {
    let $calculator = $(this);

    if (!$calculator.hasClass('calculator')) return false;

    let $dialog = $('dialog[data-dialog-id="calculator-price-alert-choices-unchecked"]');

    $calculator.find('[data-conditional]').each(function () {
        let $elem = $(this),
            conditionObj = JSON.parse($(this).attr('data-conditional')),
            conditionsPassed = [];

        // loop through conditions to check if passed is true or false
        $.each(conditionObj, function () {
            let conditions = this,
                conditionPassed = true;

            $.each(conditions, function () {
                if (!conditionPassed) return false; // if a previous iteration is already false, stop loop

                let condition = this,
                    $input = $calculator.find('input[name="' + condition.field + '"]'),
                    value = '';

                if ($input.length > 0) {
                    if ($input.attr('type') === 'checkbox') {
                        let matchFound = false;

                        $calculator.find('input[name="' + condition.field + '"]:checked').each(function () {
                            value = $(this).val();
                            if (operators[condition.operator](value, condition.value)) matchFound = true;
                        });

                        conditionPassed = matchFound;
                    } else {
                        if ($input.attr('type') === 'radio') {
                            value = $calculator.find('input[name="' + condition.field + '"]:checked').val();
                        } else {
                            value = $input.val();
                        }

                        conditionPassed = !!(typeof value !== 'undefined' && operators[condition.operator](value, condition.value));
                    }
                }
            });

            conditionsPassed.push(conditionPassed);
        });

        /*if ($elem.is('.question')) { // @TODO no conditional questions for now, only options. If implemented later, be sure to add the 'question-visited' data in calculatorInit and showNextQuestion function
            let $question = $elem;

            if (conditionPassed) {
                $question.attr('data-conditional-state', 'visible');

                if ($question.nextAll('[data-question-visited]').length > 0) { // if flow is beyond this question, add slidedown
                    $question.stop().slideDown(300).attr('data-question-visited', '');
                }
            } else {
                if (!$question.is('[data-conditional-state="hidden"]')) {
                    $question.stop().slideUp(300).attr('data-conditional-state', 'hidden').removeAttr('data-question-visited');
                    $question.find('input[type="radio"]:checked, input[type="checkbox"]:checked').prop('checked', false).trigger('change'); // unset values for questions that are hidden
                }
            }

            $calculator.find('[data-question-visited]').last().addClass('question--active').siblings('.question').removeClass('question--active');
        } else */

        conditionsPassed = $.inArray(true, conditionsPassed) !== -1; // if one of set conditions is true

        if ($elem.is('.choice')) {
            if (conditionsPassed) {
                $elem.attr('data-conditional-state', 'visible').show();
            } else {
                $elem.attr('data-conditional-state', 'hidden').hide();

                if ($elem.find('.choice__input').prop('checked')) {
                    $elem.find('.choice__input').prop('checked', false);

                    if ($dialog.length > 0) {
                        let deselectedQuestion = $elem.closest('.question').find('.question__title').text(),
                            $deselectedQuestionElem = $dialog.find('.deselected-question'),
                            deselectedOption = $elem.find('[class*="__title"]').text(),
                            $deselectedOptionElem = $dialog.find('.deselected-question-option');

                        $deselectedQuestionElem.text('"'+$.trim(deselectedQuestion)+'"');
                        $deselectedOptionElem.text('"'+$.trim(deselectedOption)+'"');

                        $dialog[0].showModal();
                        $('.page-wrapper').trigger('lenisStop');
                    }
                }
            }
        } else {
            // other static elements like titles, descriptions, etc.
            if (conditionsPassed) {
                $elem.attr('data-conditional-state', 'visible').show();
            } else {
                $elem.attr('data-conditional-state', 'hidden').hide();
            }
        }
    });
}

$.fn.populateFormFields = function () {
    let $calculator = $(this);

    if (!$calculator.hasClass('calculator')) return false;

    let $form = $calculator.find('.calculator__form');

    if ($form.length < 1) return false;

    $calculator.find('.question').each(function () {
        $(this).find('input, textarea').each(function () {
            let name = $(this).attr('name'),
                value;

            if ('checkbox' === $(this).attr('type')) {
                value = [];
                value.push($calculator.find('input[name="' + name + '"]:checked').closest('.choice').find('.choice__title').text().trim());
            } else if ('radio' === $(this).attr('type')) {
                value = $calculator.find('input[name="' + name + '"]:checked').closest('.choice').find('.choice__title').text().trim();
            } else {
                value = $(this).val();
            }

            // send to form input with class
            if ($(this).closest('.question').hasClass('question--hidden') || $(this).closest('.question').is('[data-conditional-state="hidden"]')) {
                $form.find('.calculator-' + name + ' input').val(''); // clear field values if question is hidden
            } else {
                $form.find('.calculator-' + name + ' input').val(value);
            }
        });
    });
}

$.fn.runCalculation = function() {
    let $calculator = $(this);

    if (!$calculator.hasClass('calculator')) return false;

    // add trigger so calculation can be added in separate file
    $calculator.trigger('runCalculation');

    $calculator.populateFormFields();
}

function calculateRangeMarkers(min, max, stepSize) {
    const range = max - min,
        totalSteps = range / stepSize;

    let markerInterval;

    if (totalSteps <= 10) {
        markerInterval = stepSize;
    } else {
        markerInterval = Math.ceil(range/10);
    }

    // Generate the marker points
    const markers = [];

    for (let i = min; i <= max; i += markerInterval) {
        markers.push(i.toFixed(10)); // Fix for floating point precision
    }

    // Ensure maximum value is always added
    if (markers[markers.length - 1] !== max.toFixed(10)) {
        //markers[markers.length - 1] = max.toFixed(10); // replaces last value with max
        markers.push(max.toFixed(10)); // adds max value
    }

    return markers;
}

$.fn.updateRangeLabels = function () {
    let $input = $(this);

    if (!$input.hasClass('question__input') && !$input.is('[type="range"]')) return false;

    let min = parseFloat($(this).attr('min')),
        max = parseFloat($(this).attr('max')),
        stepSize = parseFloat($(this).attr('step')),
        $labels = $(this).closest('.question').find('.question__input-markers');

    $labels.find('span').remove();

    // calculate how many extra markers there should be
    let markers = calculateRangeMarkers(min, max, stepSize);

    for (let i = 0; i < markers.length; i++) {
        let value = +parseFloat(markers[i]).toFixed(1);

        $labels.append('<span class="marker"><span class="marker__value">'+value+'</span></span>');
    }
}

$.fn.calculatorInit = function () {
    let $calculator = $(this);

    if (!$calculator.hasClass('calculator')) return false;

    // set active state to first question
    if ($('.question.question--current', this).length < 1) {
        $('.question', this).first().addClass('question--current'); // .attr('data-question-visited', '');
    }

    $('.question.question--current', this).stop().slideDown(300);

    // Restrict input to digits by using a regular expression filter.
    $('input[inputmode="numeric"]', this).inputFilter(function(value) {
        return /^\d*$/.test(value);
    });

    $('.question input, .question textarea', this).on('change update', function () {
        $calculator.checkConditionals();
        $calculator.setQuestionNumbers();
        $calculator.runCalculation();
        $calculator.showNextQuestion();
    });

    $('.question input[type="range"]', this).each(function () {
        $(this).updateRangeLabels();
    });

    $('.question input[type="range"]', this).on('click', function () {
        let modified = $(this).attr('data-range-modified'),
            dont_modify = $(this).attr('data-range-dont-modify');

        if (typeof dont_modify === 'undefined') {
            if (typeof modified === 'undefined') {
                $(this).attr('data-range-modified', '');
            }
        } else {
            $(this).removeAttr('data-range-dont-modify');
        }

        $calculator.checkConditionals();
        $calculator.setQuestionNumbers();
        $calculator.runCalculation();
        $calculator.showNextQuestion();
    }).on('input', function () {
        let modified = $(this).attr('data-range-modified'),
            dont_modify = $(this).attr('data-range-dont-modify'),
            update_input_labels = $(this).attr('data-range-update-labels');

        if (typeof dont_modify === 'undefined') {
            if (typeof modified === 'undefined') {
                $(this).attr('data-range-modified', '');
            }
        } else {
            $(this).removeAttr('data-range-dont-modify');
        }

        let min = $(this).attr('min'),
            max = $(this).attr('max'),
            value = $(this).val(),
            $wrapper = $(this).closest('.question__input-wrapper'),
            $valueDisplay = $wrapper.find('.question__input-value span');

        if ($valueDisplay.length > 0) $valueDisplay.css('left', (value - min) / (max - min) * 100 + '%').text(value);

        if (typeof update_input_labels !== 'undefined') {
            $(this).updateRangeLabels();
            $(this).removeAttr('data-range-update-labels');
        }

        $calculator.runCalculation();
    });

    // modify value elements in calculator if they change
    $('[data-calculator-value]', this).on('valueUpdate', function () {
        let parentElem = $(this).closest('.calculator__data-expand'),
            value = $(this).text();

        if (parentElem.length > 0) {
            value = parseInt(value);

            if (typeof value !== 'undefined' && value > 0) {
                parentElem.stop().slideDown(150);
            } else {
                parentElem.stop().slideUp(150);
            }
        }
    });

    // set limit to checkbox options
    $('[data-max-options]', this).each(function () {
        let $container = $(this),
            max = parseInt($(this).attr('data-max-options'));

        $('input[type="checkbox"]').on('change', function () {
            let checkedCount = $container.find('input[type="checkbox"]:checked').length;

            if (checkedCount >= max) {
                $container.find('input[type="checkbox"]:not(:checked)').prop('disabled', true);
            } else {
                $container.find('input[type="checkbox"]').prop('disabled', false);
            }
        });
    });

    $calculator.checkConditionals();
    $calculator.setQuestionNumbers();
    $calculator.runCalculation();
}

let operators = {
    '==': function(a, b) { return a === b },
    '!=': function(a, b) { return a !== b },
    '<': function(a, b) { return a < b },
    '<=': function(a, b) { return a <= b },
    '>': function(a, b) { return a > b },
    '>=': function(a, b) { return a >= b }
}

$('.calculator').each(function() {
    $(this).calculatorInit();
});
